var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[(_vm.currentView==='H5List')?_c('h5-list'):_vm._e(),(_vm.currentView==='h5Deploy')?_c('h5-deploy'):_vm._e(),(_vm.currentView==='H5AccessCode')?_c('h5-access-code'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }